// extracted by mini-css-extract-plugin
module.exports = {"figure":"figure--3BN00","figCaption":"figCaption--1ctFX","main":"main--S0aCK","noData":"noData--1qKuJ","sub":"sub--1XiJZ","img":"img--1jfgm"};